import { createSelector } from 'reselect';
import { RootState } from 'src/redux/store';

const selectVoucherState = (state: RootState) => state.voucher;

const selectVoucherDetails = createSelector(
  selectVoucherState,
  (state) => state.voucherDetails
);

const selectIsLoading = createSelector(
  selectVoucherState,
  (state) => state.isLoading
);

const selectVoucherList = createSelector(
  selectVoucherState,
  (state) => state.vouchersList
);

const selectMeta = createSelector(selectVoucherState, (state) => state.meta);

const selectIsListLoading = createSelector(
  selectVoucherState,
  (state) => state.isListLoading
);

const selectFilter = createSelector(
  selectVoucherState,
  (state) => state.filter
);

const selectProducts = createSelector(
  selectVoucherState,
  (state) => state.products
);

const selectProductsMeta = createSelector(
  selectVoucherState,
  (state) => state.productsMeta
);

const selectIsProductsLoading = createSelector(
  selectVoucherState,
  (state) => state.isProductsLoading
);

const selectConsumedVoucherDetails = createSelector(
  selectVoucherState,
  (state) => state.consumedVoucherDetails
);

const selectIsConsumedListLoading = createSelector(
  selectVoucherState,
  (state) => state.isConsumedListLoading
);

export const selectors = {
  selectVoucherList,
  selectIsListLoading,
  selectFilter,
  selectMeta,
  selectVoucherDetails,
  selectProducts,
  selectProductsMeta,
  selectIsProductsLoading,
  selectIsLoading,
  selectConsumedVoucherDetails,
  selectIsConsumedListLoading
};
